// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"144":"971ae276578788a1","466":"f0fb550d884b31c6","540":"3f2df3af926d575f","730":"dee39842a638b1bb"}[chunkId] + ".js";
};